import axiosClient from "../axios/axiosClient";

export function getStudentCategories() {
  return axiosClient.get("/student-categories");
}

export function getStudentCategory(studentCategoryId) {
  return axiosClient.get(`/student-categories/${studentCategoryId}`);
}

export function createStudentCategory(data) {
  return axiosClient.post("/student-categories", data);
}

export const updateStudentCategory = (studentCategoryId, data) => {
  return axiosClient.put(`/student-categories/${studentCategoryId}`, data);
};

export function deleteStudentCategory(studentCategoryId) {
  return axiosClient.delete(`/student-categories/${studentCategoryId}`);
}
